import * as React from "react";
import type { SVGProps } from "react";
const SvgCloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="close_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M723.2 783.53a42.667 42.667 0 0 0 60.33-60.33L572.33 512l211.2-211.2a42.667 42.667 0 0 0-60.33-60.33L512 451.67l-211.2-211.2a42.667 42.667 0 0 0-60.33 60.33L451.67 512l-211.2 211.2a42.667 42.667 0 1 0 60.33 60.33L512 572.33l211.2 211.2z"
    />
  </svg>
);
export default SvgCloseIcon;
